import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer className="main_footer">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-6 col-sm-6">
                        <div className="footer-wrapper">
                            <div className="footer-logo-wrapper">
                                <img src="../../../images/logo-white1.png" alt="logo" />
                                <h2>Sign up and save</h2>
                                <p>Subscribe to get special offers, free giveaways, and once-in-a-lifetime deals.</p>
                            </div>
                            <div className="footer-social-icon-wrapper">
                                <div className="footer-social-icon">
                                    <Link target="_blank" to="https://www.facebook.com/profile.php?id=61574970535098" title="About Gailee – Learn about our brand"> <i className="fa-brands fa-facebook-f"></i></Link>
                                    <Link target="_blank" to="https://www.instagram.com/gaileelifestyle/profilecard/?igsh=d2JrejVyaWZvZm44" title="About Gailee – Learn about our brand"><i className="fa-brands fa-instagram"></i></Link>
                                    {/* <Link to="#" title="About Gailee – Learn about our brand"><i className="fa-brands fa-x-twitter"></i></Link>
                                    <Link to="#" title="About Gailee – Learn about our brand"><i className="fa-brands fa-linkedin-in"></i></Link> */}
                                    <Link target="_blank" to="https://pin.it/ZpZmxvKEQ" title="About Gailee – Learn about our brand"><i className="fa-brands fa-pinterest-p"></i></Link>
                                    {/* https://pin.it/ZpZmxvKEQ */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 ">
                        <div className="footer-wrapper">
                            <div className="footer_content">
                                <h2>Our Support</h2>
                                <ul>
                                    <li><img src="../../../images/footer-arrow.svg" alt="footer-arrow" /><Link to="/" title="About Gailee – Learn about our brand">Home</Link></li>
                                    <li><img src="../../../images/footer-arrow.svg" alt="footer-arrow" /><Link to="/about-us" title="About Gailee – Learn about our brand">About us</Link></li>
                                    <li><img src="../../../images/footer-arrow.svg" alt="footer-arrow" /><Link to="/blog" title="About Gailee – Learn about our brand">Blog</Link></li>
                                    <li><img src="../../../images/footer-arrow.svg" alt="footer-arrow" /><Link to="/contact-us" title="About Gailee – Learn about our brand">Contact Us</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6">
                        <div className="footer-wrapper">
                            <div className="footer_content">
                                <h2>Our Information</h2>
                                <ul>
                                    <li><img src="../../../images/footer-arrow.svg" alt="arrow" /><Link to="/faqs" title="About Gailee – Learn about our brand">FAQs</Link></li>
                                    <li><img src="../../../images/footer-arrow.svg" alt="arrow" /><Link to="/privacy-policy" title="About Gailee – Learn about our brand">Privacy Policy</Link></li>
                                    <li><img src="../../../images/footer-arrow.svg" alt="arrow" /><Link to="/terms-and-conditions" title="About Gailee – Learn about our brand">Terms & Conditions</Link></li>
                                    <li><img src="../../../images/footer-arrow.svg" alt="arrow" /><Link to="/refund-and-return-policy" title="About Gailee – Learn about our brand">Refund & return Policy</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6">
                        <div className=" footer-wrapper">
                            <div className="footer_content addersh">
                                <h2>Contact Us</h2>
                                <ul>
                                    <li><strong>Office: </strong>4/766 Vibhav Khand, Gomtinagar, Lucknow - 226010</li>
                                    <li><strong>Phone No. </strong><Link to="tel:9987468687" title="About Gailee – Learn about our brand">+91 87565 62626</Link></li>
                                    <li><strong>E-mail: </strong><Link to="mailto:support@gailee.in" title="About Gailee – Learn about our brand">support@gailee.in</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <div className="footer-rights-wrapper">
                <p className="footer-copyright-text">© 2024 Gailee. Developed by
                    <Link to="https://ishivax.com/" target="_blank" className="footer-copyright-link" title="About Gailee – Learn about our brand">iShivax</Link>
                </p>
            </div>
        </footer>
    )
}

export default Footer;